type BadgeProps = {
  label: React.ReactNode;
  classes: string;
};

export const Badge: React.FC<BadgeProps> = ({ label, classes }) => (
  <span className={`inline-flex items-center gap-1.5 px-3 py-1 text-sm font-medium ${classes}`}>
    {label}
  </span>
);
